module.exports = __webpack_public_path__ + "static/media/Proximus-Regular.8c2b4c0a.woff";